<template></template>

<script>
export default {
  name: "StripeIdentityModal",
  props: {
    actionUrl: String,
    stripeKey: String,
  },
  mounted() {
    let stripe = Stripe(this.stripeKey);
    fetch(this.actionUrl)
        .then(response => response.json()
        )
        .then(session => {
          return stripe.verifyIdentity(session.secret)
        })
        .catch(error => {
          console.error(`Error: ${error}`)
        })
  }
}
</script>
